import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@neo/primitives/alert-dialog'
import { Button } from '@neo/primitives/button'

interface DuplicateStartNodeModalActions {
  onCancel: () => void
  onReplaceAndPaste: () => void
  onIgnoreAndPaste: () => void
}

interface DuplicateStartNodeModalProps {
  isOpen: boolean
  actions: DuplicateStartNodeModalActions
}

export const DuplicateStartNodeModal = ({
  isOpen,
  actions: { onCancel, onReplaceAndPaste, onIgnoreAndPaste },
}: DuplicateStartNodeModalProps) => (
  <AlertDialog
    open={isOpen}
    onOpenChange={(open) => {
      // If the modal is closed by clicking outside or pressing Esc, treat it as a cancel
      if (!open) {
        onCancel()
      }
    }}
  >
    <AlertDialogContent data-testid="alert-dialog-duplicate-start-node">
      <AlertDialogHeader>
        <AlertDialogTitle>Start Node Conflict</AlertDialogTitle>
        <AlertDialogDescription>
          The workflow you&apos;re importing contains a start node, but your current flow already
          has one. A workflow can only have one start node at a time.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Button
          variant="outline"
          onClick={onReplaceAndPaste}
          data-testid="button-replace-start-node"
        >
          Replace with Imported
        </Button>
        <Button variant="default" onClick={onIgnoreAndPaste} data-testid="button-ignore-start-node">
          Keep Existing
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
)
